import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const legacySurveyDetailSearchSchema = z.object({
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

// Surveys moved to the top-level /surveys product area. Keep this route as a
// redirect so old links and bookmarks still work, carrying their deep-link
// organization and mode across.
export const Route = createFileRoute(
    '/_app/(main)/outreaches/survey/$survey-id',
)({
    validateSearch: legacySurveyDetailSearchSchema,
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: '/surveys/$survey-id',
            params,
            search,
            replace: true,
        });
    },
});
